import gateway from './gateway.svg';
import calender from './calendar.svg'
import gatewayUnselect from './gatewayUnselect.svg'
export const gatewayIcon = gateway;
export const calenderIcon = calender;
export const gatewayUnselectIcon = gatewayUnselect;